.sdl-content--ecostruxure {
  padding-bottom: 22px;
  background-color: #ffffff;
}